import { FC } from 'react'
import { Helmet } from 'react-helmet'

const Dashboard: FC = () => {
  return (
    <>
      <Helmet>
        <title>ORMS Dashboard</title>
      </Helmet>
      <section>
        <h1 className="py-3 text-center text-3xl font-bold">Welcome to ORMS</h1>
      </section>
    </>
  )
}

export default Dashboard
